import React, { useState } from "react";
import { Link } from "react-router-dom";

function Footer() {
  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    console.log("Newsletter subscription:", email);
    // TODO: Integrate with API (e.g., Mailchimp or EmailJS)
    setEmail("");
  };

  return (
    <footer className="footer-section fix footer-3 section-padding pb-0">
      <div className="container">
        <div className="footer-top style-new">
          <div className="logo-items">
            <Link to="/">
              <img src="./assets/img/logo/fayah-logo.png" alt="Fayah Travels Logo" />
            </Link>
          </div>
          <div className="contact-info">
            <div className="contact-items">
              <div className="icon">
                <i className="fa-solid fa-phone"></i>
              </div>
              <div className="content">
                <h6>
                  <a href="tel:+254742940940">+254 742 940 940</a>
                </h6>
              </div>
            </div>
            <div className="contact-items">
              <div className="icon">
                <i className="fa-regular fa-envelope"></i>
              </div>
              <div className="content">
                <h6>
                  <a href="mailto:info@fayahtravels.com">info@fayahtravels.com</a>
                </h6>
              </div>
            </div>
            <div className="contact-items">
              <div className="icon">
                <i className="fa-regular fa-location-dot"></i>
              </div>
              <div className="content">
                <h6>Lamka Court, Katani Rd, Syokimau, Kenya</h6>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-widget-wrapper-new style-2 style-new-area">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" data-wow-delay=".2s">
              <div className="single-widget-items">
                <div className="footer-content style-3">
                  <h3>Subscribe Newsletter</h3>
                  <p>Get Our Latest Deals and Update</p>
                  <div className="footer-input style-3">
                    <form onSubmit={handleNewsletterSubmit}>
                      <input
                        type="email"
                        id="email2"
                        placeholder="Your email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <button className="newsletter-btn theme-btn style-3" type="submit">
                        Subscribe <i className="fa-sharp fa-regular fa-arrow-right"></i>
                      </button>
                    </form>
                  </div>
                  <div className="social-icon style-3 d-flex align-items-center">
                    <a href="/contact-us">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="/contact-us">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="/contact-us">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="/contact-us">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 ps-lg-5 wow fadeInUp" data-wow-delay=".4s">
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4 className="style-3">Company</h4>
                </div>
                <ul className="list-items style-3">
                  <li>
                    <Link to="/tour-details">Mombasa Beach Adventures</Link>
                  </li>
                  <li>
                    <Link to="/tour-details">Nairobi City Tours</Link>
                  </li>
                  <li>
                    <Link to="/tour-details">Maasai Mara Safaris</Link>
                  </li>
                  <li>
                    <Link to="/tour-details">Diani Beach Getaways</Link>
                  </li>
                  <li>
                    <Link to="/tour-details">Amboseli National Park</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6 ps-lg-5 wow fadeInUp" data-wow-delay=".6s">
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4 className="style-3">Quick Links</h4>
                </div>
                <ul className="list-items style-3">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/blog">Blog</Link>
                  </li>
                  <li>
                    <Link to="/tours">Tour</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 ps-lg-5 wow fadeInUp" data-wow-delay=".8s">
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4 className="style-3">Gallery Post</h4>
                </div>
                <div className="footer-gallery">
                  <div className="gallery-wrap">
                    <div className="gallery-item">
                      <div className="thumb style-3">
                        <a href="assets/img/footer/gallery-1.jpg" className="img-popup">
                          <img src="assets/img/footer/gallery-1.jpg" alt="gallery-img" />
                          <div className="icon">
                            <i className="far fa-plus"></i>
                          </div>
                        </a>
                      </div>
                      <div className="thumb style-3">
                        <a href="assets/img/footer/gallery-2.jpg" className="img-popup">
                          <img src="assets/img/footer/gallery-2.jpg" alt="gallery-img" />
                          <div className="icon">
                            <i className="far fa-plus"></i>
                          </div>
                        </a>
                      </div>
                      <div className="thumb style-3">
                        <a href="assets/img/footer/gallery-3.jpg" className="img-popup">
                          <img src="assets/img/footer/gallery-3.jpg" alt="gallery-img" />
                          <div className="icon">
                            <i className="far fa-plus"></i>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="gallery-item">
                      <div className="thumb style-3">
                        <a href="assets/img/footer/gallery-4.jpg" className="img-popup">
                          <img src="assets/img/footer/gallery-4.jpg" alt="gallery-img" />
                          <div className="icon">
                            <i className="far fa-plus"></i>
                          </div>
                        </a>
                      </div>
                      <div className="thumb style-3">
                        <a href="assets/img/footer/gallery-5.jpg" className="img-popup">
                          <img src="assets/img/footer/gallery-5.jpg" alt="gallery-img" />
                          <div className="icon">
                            <i className="far fa-plus"></i>
                          </div>
                        </a>
                      </div>
                      <div className="thumb style-3">
                        <a href="assets/img/footer/gallery-6.jpg" className="img-popup">
                          <img src="assets/img/footer/gallery-6.jpg" alt="gallery-img" />
                          <div className="icon">
                            <i className="far fa-plus"></i>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom style-2">
          <div className="footer-wrapper">
            <p className="wow fadeInUp" data-wow-delay=".3s">
              ©<span className="style-3">Fayah Travels</span> 2025. All Rights Reserved
            </p>
            <ul className="bottom-list wow fadeInUp" data-wow-delay=".5s">
              <li>
                <Link to="/terms">Terms of Use</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy & Environmental Policy</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;